import { HttpMethod } from '../../http-method'

export const deleteNotificationScheduleRequest = (uuid: string, dryRun: boolean) => ({
  method: HttpMethod.DELETE,
  url: `modules/notification-schedules/${uuid}`,
  params: {
    DryRun: dryRun
  }
})
